import common from '@/js/lib/common';
import SigninSignup from '@/js/components/common/ui/SigninSignup.vue';
import { mountModal } from './helper/dynamic-modal';

export const socialProviders = [
  {
    id: 'facebook',
    label: 'Facebook',
    svg: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 48 48"><path d="M48 24C48 10.7438 37.2562 0 24 0C10.7438 0 0 10.7438 0 24C0 35.9813 8.775 45.9094 20.25 47.7094V30.9375H14.1562V24H20.25V18.7125C20.25 12.6984 23.8313 9.375 29.3156 9.375C31.9406 9.375 34.6875 9.84375 34.6875 9.84375V15.75H31.6594C28.6781 15.75 27.75 17.6016 27.75 19.5V24H34.4062L33.3422 30.9375H27.75V47.7094C39.225 45.9094 48 35.9813 48 24Z" fill="#1877F2"/><path d="M33.3422 30.9375L34.4062 24H27.75V19.5C27.75 17.6016 28.6781 15.75 31.6594 15.75H34.6875V9.84375C34.6875 9.84375 31.9406 9.375 29.3156 9.375C23.8313 9.375 20.25 12.6984 20.25 18.7125V24H14.1562V30.9375H20.25V47.7094C21.4734 47.9016 22.725 48 24 48C25.275 48 26.5266 47.9016 27.75 47.7094V30.9375H33.3422Z" fill="white"/></svg>',
  },
  {
    id: 'twitter',
    label: 'X',
    svg: '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="24" viewBox="0 0 1200 1227"><path d="M714.163 519.284L1160.89 0H1055.03L667.137 450.887L357.328 0H0L468.492 681.821L0 1226.37H105.866L515.491 750.218L842.672 1226.37H1200L714.137 519.284H714.163ZM569.165 687.828L521.697 619.934L144.011 79.6944H306.615L611.412 515.685L658.88 583.579L1055.08 1150.3H892.476L569.165 687.854V687.828Z" fill="black"/></svg>',
  },
];

export const signinSignup = ({ active, next, callback }: { active?: 'signin' | 'signup'; next?: string; callback?: () => void } = {}) => {
  const turnstileSiteKey = common.env.Pallet.cloudflare?.turnstileSiteKey || '';
  mountModal({
    Component: SigninSignup,
    props: {
      active,
      next,
      turnstileSiteKey,
      callback,
    },
  });
};
